<template>

    <div>

        <form ref="form-dados-pessoais" v-on:submit.prevent="confirmarDados()" novalidate>

            <div class="row">

                <div class="form-group col-md-8">
                    <label for="nome">Nome Completo</label>
                    <input type="text" class="form-control" name="nome" autocomplete="off" v-model="model.nome" required readonly />
                </div>
                <div class="form-group col-md-4">
                    <label for="apelido">Apelido</label>
                    <input type="text" class="form-control" name="apelido" autocomplete="off" v-model="model.apelido" required readonly />
                </div>

                <div class="form-group col-md-6">
                    <label for="cpF_CNPJ">
                        CPF ou CNPJ
                        <i class="fas fa-question-circle" v-b-tooltip title="Não é possível alterar o CPF ou CNPJ. Caso esteja incorreto, por favor informe sua escola."></i>
                    </label>
                    <input type="text" class="form-control" name="cpF_CNPJ" autocomplete="off" v-model="model.cpF_CNPJFormatado" readonly required />
                </div>
                <div class="form-group col-md-6">
                    <label for="rG_IE">RG</label>
                    <input type="text" class="form-control" name="rG_IE" autocomplete="off" v-model="model.rG_IE" v-mask="mask_rg" maxlength="12" readonly />
                </div>

                <div class="form-group col-md-4">
                    <label for="dataNascimento">Data Nascimento</label>
                    <input type="text" v-datepicker class="form-control" maxlength="10" name="dataNascimento" autocomplete="off" v-model="model.dataNascimento" required readonly />
                </div>
                <!--<div class="form-group col-md-8">
                    <label>Sexo</label>
                    <div class="form-group">
                        <div class="btn-group btn-group-toggle genero" data-toggle="buttons">
                            <label class="btn border border-primary radius-left px-2 text-primary" v-bind:class="{ active: model.sexo == 1 }">
                                <input type="radio" name="sexo" v-model="model.sexo" value="1"><i class="fas fa-male"></i> Masculino
                            </label>
                            <label class="btn border border-primary px-2 text-primary" v-bind:class="{ active: model.sexo == 2 }">
                                <input type="radio" name="sexo" v-model="model.sexo" value="2"><i class="fas fa-female"></i> Feminino
                            </label>
                            <label class="btn border border-primary radius-right px-2 text-primary" v-bind:class="{ active: model.sexo == null }">
                                <input type="radio" name="sexo" v-model="model.sexo" value="null"> Não informado
                            </label>
                        </div>
                    </div>
                </div>-->

            </div>
            <div class="row mt-2">

                <div class="form-group col-md-6">
                    <label for="email">
                        E-mail
                        <i class="fas fa-question-circle" v-b-tooltip title="Não é possível alterar o e-mail. Caso esteja incorreto, por favor informe sua escola."></i>
                    </label>
                    <input type="email" class="form-control" name="email" autocomplete="off" v-model="model.email" required />
                </div>
                <div class="form-group col-md-6">
                    <label for="emailSecundario">E-mail alternativo</label>
                    <input type="email" class="form-control" name="emailSecundario" autocomplete="off" v-model="model.emailAlternativo" readonly />
                </div>

                <div class="form-group col-md-4">
                    <label for="celular">Celular</label>
                    <input type="text" v-mask="'(##)#####-####'" maxlength="14" class="form-control" name="celular" autocomplete="off" v-model="model.celular" required readonly />
                </div>
                <div class="form-group col-md-4">
                    <label for="telefone">Telefone</label>
                    <input type="text" class="form-control" name="telefone" v-mask="'(##)####-####'" maxlength="13" autocomplete="off" v-model="model.telefone" readonly />
                </div>
                <div class="form-group col-md-4">
                    <label for="comercial">Telefone Comercial</label>
                    <input type="text" v-mask="'(##)#####-####'" maxlength="14" class="form-control" name="comercial" autocomplete="off" v-model="model.telefoneComercial" readonly />
                </div>

            </div>
            <div class="row mt-2">
                <div class="form-group col-md-4">
                    <label for="cep">CEP</label>
                    <input type="text" class="form-control" name="cep" autocomplete="off" v-mask="'#####-###'" maxlength="9" v-model="model.cep" @change="buscarCep()" required readonly />
                </div>
                <div class="form-group col-md-6">
                    <label for="rua">Endereço</label>
                    <input type="text" class="form-control" name="rua" autocomplete="off" v-model="model.rua" required readonly />
                </div>
                <div class="form-group col-md-2">
                    <label for="numero">Número</label>
                    <input type="text" class="form-control" name="numero" autocomplete="off" v-model="model.numero" required readonly />
                </div>

                <div class="form-group col-md-3">
                    <label for="complemento">Complemento</label>
                    <input type="text" class="form-control" name="complemento" autocomplete="off" v-model="model.complemento"  maxlength="50" readonly />
                </div>
                <div class="form-group col-md-3">
                    <label for="bairro">Bairro</label>
                    <input type="text" class="form-control" name="bairro" autocomplete="off" v-model="model.bairro" required readonly />
                </div>
                <div class="form-group col-md-4">
                    <label for="cidade">Cidade</label>
                    <input type="text" class="form-control" name="cidade" autocomplete="off" v-model="model.cidade" required readonly />
                </div>
                <div class="form-group col-md-2">
                    <label for="uf">UF</label>
                    <input type="text" class="form-control" name="uf" autocomplete="off" v-model="model.uf" required readonly />
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-6">
                    <button type="button" class="btn btn-light border-primary rounded-pill previous-button px-4" @click="sendBack()">Voltar</button>
                </div>
                <div class="col-6 text-right">
                    <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="confirmarDados()">Continuar</button>
                </div>
            </div>
        </form>
        <div class="alert alert-danger mt-4">
            Caso tenha encontrado alguma informação incorreta ou incompleta, por favor entre em contato com a sua escola CNA para ajuste.
        </div>
    </div>



</template>



<script>
    import { Api } from '@/common/api'
    import base from '@/common/base.js'
    export default {
        name: 'cadastro-dados-pessoais',
        mixins: [base],
        props: {
            model: Object
        },
        data: () => ({

        }),
        methods: {
            confirmarDados() {

                if (this.formValidate() == false)
                    return;

                this.showLoading()
                new Api('pessoacna').post(this.model).then(result => {
                    this.defaultSuccessResult("Usuário criado. Agora vamos configurar o seu acesso!");
                    this.$emit('on-next', result.data);
                }, err => {
                    this.defaultErrorResult(err, true);
                })
            },
            sendBack() {
                this.$emit('on-back')
            },

            formValidate() {
                var $form = this.$refs["form-dados-pessoais"];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

        },

        mounted() {

        }
    };
</script>
